import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import React from 'react';
import loadable from '@loadable/component';
import { HashRouter, Router, Switch, Route } from 'react-router-dom';
import { createHashHistory } from 'history';
import { syncHistoryWithStore } from 'mobx-react-router';
import styles from './index.scss';
import * as store from '@store/index';
import PageLoading from '@components/PageLoading';
import Error from '@components/Error';
import Provider from './Provider';
import IntlWrapper from './IntlWrapper';
var hashHistory = createHashHistory();
var history = syncHistoryWithStore(hashHistory, store.routerStore);
var loadableOptions = {
  fallback: /*#__PURE__*/React.createElement(PageLoading, null)
};
var Home = loadable(() => import(
/* webpackChunkName: "home" */
'@views/Home'), loadableOptions);

var AppWrapper = (_ref) => {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.appWrapper
  }, children);
};

function App() {
  return /*#__PURE__*/React.createElement(Provider, null, /*#__PURE__*/React.createElement(IntlWrapper, null, /*#__PURE__*/React.createElement(AppWrapper, null, /*#__PURE__*/React.createElement(Router, {
    history: history
  }, /*#__PURE__*/React.createElement(HashRouter, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: Home
  }), /*#__PURE__*/React.createElement(Route, {
    component: Error
  })))))));
}

export default App;